module.exports = __webpack_public_path__ + "static/media/bkst_site_books.c7c83cf8.jpg";